document.addEventListener('DOMContentLoaded', () => {
  const accountMenu = document.querySelector('.header__account-menu')
  if (!accountMenu || !accountMenu.querySelector('.header__account-dropdown')) return

  let hideTimer = null

  const cancelHide = () => clearTimeout(hideTimer)
  const scheduleHide = () => {
    cancelHide()
    hideTimer = setTimeout(() => accountMenu.classList.remove('is-open'), 4000)
  }

  accountMenu.addEventListener('mouseenter', () => {
    cancelHide()
    accountMenu.classList.add('is-open')
  })
  accountMenu.addEventListener('mouseleave', scheduleHide)
  document.addEventListener('click', (e) => {
    if (!accountMenu.contains(e.target)) {
      cancelHide()
      accountMenu.classList.remove('is-open')
    }
  })
})
